<script>
/**
 * @overview 表单提交控制组件
 *
 * @author huojinzhao
 */

export default {
  name: "AppMasker",

  props: {
    titleSubmit: {
      type: String,
      default: "保存",
    },

    titleCancel: {
      type: String,
      default: "取消",
    },

    submitting: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template slot="footer">
  <div class="app-form-submit">
    <el-button
      :loading="submitting"
      :title="titleSubmit"
      type="success"
      icon="el-icon-check"
      circle
      @click="$emit('submit')"
    />
    <el-button
      :title="titleCancel"
      type="danger"
      icon="el-icon-close"
      circle
      @click="$emit('cancel')"
    />
  </div>
</template>

<style lang="postcss">
.app-form-submit {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.app-form-submit .el-button:last-child {
  margin-left: 2em;
}
</style>
